import { createGlobalStyle } from "styled-components";
import ShamelFamilySansLightttf from "../assets/fonts/ShamelFamily-SansLight.ttf";
import ShamelFamilySansBookttf from "../assets/fonts/ShamelFamily-SansBook.ttf";
import ShamelFamilySansMediumttf from "../assets/fonts/ShamelFamily-SansMedium.ttf";
import ShamelFamilySansBoldttf from "../assets/fonts/ShamelFamily-SansBold.ttf";
import CapriolaRegularttf from "../assets/fonts/Capriola-Regular.ttf";

const GlobalStyle = createGlobalStyle`
  @font-face {
    font-family: "ShamelSans";
    src: url(${ShamelFamilySansLightttf}) format("truetype");
    font-weight: 300;
    font-display: swap;
  }

  @font-face {
    font-family: "ShamelSans";
    src: url(${ShamelFamilySansBookttf}) format("truetype");
    font-weight: 400;
    font-display: swap;
  }

  @font-face {
    font-family: "ShamelSans";
    src: url(${ShamelFamilySansMediumttf}) format("truetype");
    font-weight: 500;
    font-display: swap;
  }

  @font-face {
    font-family: "ShamelSans";
    src: url(${ShamelFamilySansBoldttf}) format("truetype");
    font-weight: 700;
    font-display: swap;
  }

  @font-face {
    font-family: "Capriola";
    src: url(${CapriolaRegularttf}) format("truetype");
    font-weight: normal;
    font-display: swap;
  }

  * {
    font-family: "ShamelSans" !important;
  }

  body,
  html {
    margin: 0;
    padding: 0;
    overflow-x: hidden;
    scroll-behavior: smooth;
    position: relative;
  }

  *, *::before, *::after {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  a {
    text-decoration: none;
    color: inherit;
  }

  button {
    font-family: inherit;
  }
`;

export default GlobalStyle;
